<span #svg></span>

<span *ngIf="bandeira.imagemUrl && bandeira.imagemUrl != ' '">
  <img  [src]="bandeira.imagemUrl" style="max-width: 30px; max-height: 20px" alt="{{textoString}}" >
</span>


<span class="ml-2 d-inline cpointer"><b>{{textoString}}</b></span>
